import { Phone, MessageCircle, MapPin } from "lucide-react";
import { BUSINESS, MAPS_DIRECTIONS } from "@/data/site";
import { waGeneral } from "@/lib/wa";

export default function MobileContactBar() {
  const actions = [
    {
      label: "Ara",
      icon: Phone,
      href: `tel:${BUSINESS.phoneRaw}`,
      testid: "mobilebar-call",
    },
    {
      label: "WhatsApp",
      icon: MessageCircle,
      href: waGeneral(),
      testid: "mobilebar-whatsapp",
      target: "_blank",
    },
    {
      label: "Yol Tarifi",
      icon: MapPin,
      href: MAPS_DIRECTIONS,
      testid: "mobilebar-directions",
      target: "_blank",
    },
  ];

  return (
    <div
      className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-espresso text-ivory grain"
      data-testid="mobile-contact-bar"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="relative z-10 grid grid-cols-3">
        {actions.map((a) => (
          <a
            key={a.label}
            href={a.href}
            target={a.target}
            rel={a.target ? "noopener noreferrer" : undefined}
            data-testid={a.testid}
            className="flex flex-col items-center justify-center gap-1 py-3 border-r border-ivory/10 last:border-r-0 active:bg-ivory/5"
          >
            <a.icon size={20} strokeWidth={1.5} className="text-gold" />
            <span className="text-[11px] tracking-wide font-medium">{a.label}</span>
          </a>
        ))}
      </div>
    </div>
  );
}
